angular.module("vgresiduos").controller("IbamaRappReportCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "declaracoes/ibama-rapp/relatorio");
		};
	}
]);
